/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type TokensReleased = {
  vestingConfig: Address;
  launch: Address;
  beneficiary: Address;
  scheduleId: number;
  amount: bigint;
};

export type TokensReleasedArgs = {
  vestingConfig: Address;
  launch: Address;
  beneficiary: Address;
  scheduleId: number;
  amount: number | bigint;
};

export function getTokensReleasedEncoder(): FixedSizeEncoder<TokensReleasedArgs> {
  return getStructEncoder([
    ['vestingConfig', getAddressEncoder()],
    ['launch', getAddressEncoder()],
    ['beneficiary', getAddressEncoder()],
    ['scheduleId', getU8Encoder()],
    ['amount', getU64Encoder()],
  ]);
}

export function getTokensReleasedDecoder(): FixedSizeDecoder<TokensReleased> {
  return getStructDecoder([
    ['vestingConfig', getAddressDecoder()],
    ['launch', getAddressDecoder()],
    ['beneficiary', getAddressDecoder()],
    ['scheduleId', getU8Decoder()],
    ['amount', getU64Decoder()],
  ]);
}

export function getTokensReleasedCodec(): FixedSizeCodec<
  TokensReleasedArgs,
  TokensReleased
> {
  return combineCodec(getTokensReleasedEncoder(), getTokensReleasedDecoder());
}
